"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerInteractionListeners = exports.blockIdInteractionGroupIdMap = void 0;
var uuid_1 = require("uuid");
var Interactions_1 = require("./Accordion/Interactions");
var Interaction_1 = require("./Block/Interaction");
var Interaction_2 = require("./Button/Interaction");
var Interaction_3 = require("./FoldableBlock/Interaction");
var Interaction_4 = require("./PageNavigation/Interaction");
var V2NavInteraction_1 = require("./PageNavigation/V2NavInteraction");
var Interaction_5 = require("./Quote/LineItem/Quantity/Interaction");
var Interaction_6 = require("./Quote/LineItem/Select/Interaction");
var Interaction_7 = require("./Quote/PlanCard/Quantity/Interaction");
var Interaction_8 = require("./Quote/PlanCard/Select/Interaction");
var Interaction_9 = require("./Quote/Total/Interaction");
var Interactions_2 = require("./ROICalculator/Slider/Interactions");
var Interaction_10 = require("./ROICalculator/Variable/Interaction");
var interaction_1 = require("./AcceptForm/interaction");
var Interaction_11 = require("./Quote/Frequency/Interaction");
var PollingElementSelector_1 = require("./Utils/PollingElementSelector");
var Interaction_12 = require("../ViewershipInteractions/UserIdle/Interaction");
var Interaction_13 = require("./Agreement/Interaction");
exports.blockIdInteractionGroupIdMap = {};
var setNewQuoteBlockInteractionGroupId = function (blockId) {
    exports.blockIdInteractionGroupIdMap[blockId] = (0, uuid_1.v4)();
};
var reregisterPlanCardListeners = function (analyticsEventSender) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, (0, PollingElementSelector_1.pause)(300)];
            case 1:
                _a.sent();
                (0, Interaction_7.registerPlanCardQuantityInputChangeListener)(analyticsEventSender);
                (0, Interaction_7.registerPlanCardQuantityStepClickListener)(analyticsEventSender);
                (0, Interaction_8.registerPlanCardClickListener)(analyticsEventSender);
                return [2];
        }
    });
}); };
var registerInteractionListeners = function (analyticsEventSender) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        (0, interaction_1.registerAcceptFormInteractionListener)(analyticsEventSender);
        (0, Interactions_1.registerAccordionListener)(analyticsEventSender);
        (0, Interaction_3.registerFoldableBlockButtonListener)(analyticsEventSender);
        (0, Interaction_4.registerPageNavigationClickListener)(analyticsEventSender);
        (0, V2NavInteraction_1.registerV2PageNavigationClickListener)(analyticsEventSender);
        (0, Interactions_2.registerROISliderChangeListener)(analyticsEventSender);
        (0, Interaction_10.registerROICalculatorButtonClick)(analyticsEventSender);
        (0, Interaction_2.registerButtonClickListener)(analyticsEventSender);
        (0, Interaction_1.registerBlockEnteredViewportObservers)(analyticsEventSender, setNewQuoteBlockInteractionGroupId);
        (0, Interaction_11.registerBillingFrequencySelectionListener)(analyticsEventSender, reregisterPlanCardListeners);
        (0, Interaction_9.registerQuoteTotalListener)(analyticsEventSender);
        (0, Interaction_6.registerLineItemSelectListener)(analyticsEventSender);
        (0, Interaction_5.registerLineItemQuantityInputListener)(analyticsEventSender);
        (0, Interaction_5.registerLineItemQuantityStepClick)(analyticsEventSender);
        (0, Interaction_7.registerPlanCardQuantityInputChangeListener)(analyticsEventSender);
        (0, Interaction_7.registerPlanCardQuantityStepClickListener)(analyticsEventSender);
        (0, Interaction_8.registerPlanCardClickListener)(analyticsEventSender);
        (0, Interaction_12.registerUserIdleTracker)(analyticsEventSender);
        (0, Interaction_13.registerAgreementViewedListener)(analyticsEventSender);
        return [2];
    });
}); };
exports.registerInteractionListeners = registerInteractionListeners;
